import PaymentMethodsPage from '@fhs-legacy/frontend/src/pages/account/payment-methods';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default PaymentMethodsPage;
